import React from 'react'

import PropTypes from 'prop-types'

import './ambassadorsbtn-cap.css'

const AmbassadorsbtnCap = (props) => {
  return (
    <div
      className={`ambassadorsbtn-cap-thq-images-elm ${props.rootClassName} `}
    >
      <div className="ambassadorsbtn-cap-container1">
        <svg viewBox="0 0 1024 1024" className="ambassadorsbtn-cap-icon1">
          <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
        </svg>
        <img
          alt={props.imageAlt1}
          src={props.imageSrc2}
          className="ambassadorsbtn-cap-image1"
        />
      </div>
      <div className="ambassadorsbtn-cap-container2">
        <svg viewBox="0 0 1024 1024" className="ambassadorsbtn-cap-icon3">
          <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
        </svg>
        <img
          alt={props.imageAlt11}
          src={props.imageSrc11}
          className="ambassadorsbtn-cap-image2"
        />
      </div>
    </div>
  )
}

AmbassadorsbtnCap.defaultProps = {
  imageSrc2: '/nav patterns/consultancy.svg',
  imageAlt11: 'image',
  imageAlt1: 'image',
  rootClassName: '',
  imageSrc11: '/nav patterns/consultancy.svg',
}

AmbassadorsbtnCap.propTypes = {
  imageSrc2: PropTypes.string,
  imageAlt11: PropTypes.string,
  imageAlt1: PropTypes.string,
  rootClassName: PropTypes.string,
  imageSrc11: PropTypes.string,
}

export default AmbassadorsbtnCap
